module.exports = new __parcel__URL__("search-spot.0b66a1bd.svg").toString();